import { requestProperties } from '../utils/request';
import { recordApi } from '../constant/Config'

//获取老师信息: https://record.olacio.com/open-recordApi/teachers/197/info
export const getRecordConfigProperties = async () => {

    const result = await requestProperties(recordApi + `/ouna-record.properties?i=${Date.now()}`);
    
    let recordEventUrlTemplate = result?.['record.data.event.url.v2'];
    let recordMediaUrlTemplate = result?.['record.data.media.url.v2'];

    // 将 http转换为https
    recordEventUrlTemplate = recordEventUrlTemplate.replace('http://', 'https://');
    recordMediaUrlTemplate = recordMediaUrlTemplate.replace('http://', 'https://');

    return [recordEventUrlTemplate, recordMediaUrlTemplate];
}
